<svg class="icon" [ngClass]="icon"><use [attr.xlink:href]="'#' + icon"></use></svg>